export default {
    props: {
        value: {
            default: null,
            type: Object
        },
        dataSourceApi: {
            default: null,
            type: String
        },
        textField: {
            default: 'Title',
            type: String
        },
        valueField: {
            default: 'ID',
            type: String
        },
        disabled: {
            default: false,
            type: Boolean
        },
        parameterMapper: {
            type: Function,
            default: function (params) {
                return {
                    take: 20
                }
            }
        },
        dataSourcePath: {
            type: String,
            default: 'Rows'
        },
        totalRowsPath: {
            type: String,
            default: 'TotalRowsCount'
        },
        comboBoxData: {
            default: null,
            type: Object
        },

    },
    data() {
        return {
            search: '',
            lastTimer: null,
            selectedItem: {},
            isOpen: false,
            results: [],
            isLoading: false,
            arrowCounter: 0,
            hasMoreItems: false,
            placeholder: i18n.$t("delegation_management.delegation_user_placeholder")
        }
    },
    computed: {
        data() {
            return this.items[this.dataSourcePath]
        }
    },
    methods: {
        onBlur() {
            if (this.search !== this.selectedItem[this.textField]) {
                this.onRemoveClick()
            }
        },
        onRemoveClick() {
            this.selectedItem = {}
            this.selectedItem[this.textField] = null
            this.selectedItem[this.valueField] = null
            this.search = ''
            this.$emit('itemSelected', this.selectedItem)
        },
        onChange(e) {
            // Let's warn the parent that a change was made
            // Is the data given by an outside ajax request?

            if (this.lastTimer !== null) clearTimeout(this.lastTimer)

            this.lastTimer = setTimeout(() => {
                this.isLoading = true
                this.filterResults(this.search)
            }, 300)
        },
        filterResults(value) {
            var orginalResult = this.comboBoxData.results;
            var csVal = value.trim().replace(/\ک/gmi, "ك").replace(/\ی/gmi, "ي");
            
            if (orginalResult) {
                var tempResult = [];
                for (var i = 0; i < orginalResult.length; i++) {

                    var item = orginalResult[i];

                    if (item.label.indexOf(csVal) > -1) {
                        tempResult.push(item);
                    }
                }
                this.results = tempResult;
            }

            this.isLoading = false;
            this.isOpen = true;
        },
        setResult(result) {
            this.selectedItem = result
            this.search = result[this.textField]
            this.isOpen = false
            this.$emit('itemSelected', this.selectedItem)
        },
        onArrowDown(evt) {
            if (this.arrowCounter < this.results.length) {
                this.arrowCounter = this.arrowCounter + 1
            }
        },
        onArrowUp() {
            if (this.arrowCounter > 0) {
                this.arrowCounter = this.arrowCounter - 1
            }
        },
        onEnter() {
            this.search = this.results[this.arrowCounter]
            this.isOpen = false
            this.arrowCounter = -1
        },
        handleClickOutside(evt) {
            if (!this.$el.contains(evt.target)) {
                this.isOpen = false
                this.arrowCounter = -1
            }
        }
    },
    watch: {
        value() {
            if (this.value) {
                this.selectedItem = this.value
                this.search = this.value[this.textField] || "";
            } else {
                this.onRemoveClick();
            }
        }
    },
    mounted() {
        if (this.comboBoxData !== null && this.comboBoxData.results) {
            this.results = this.comboBoxData.results;
        }

        this.selectedItem[this.valueField] = null
        this.selectedItem[this.textField] = null

        if (this.value !== null && this.value[this.valueField] !== null) {
            this.selectedItem = this.value
            this.search = this.value[this.textField]
        }

        document.addEventListener('click', this.handleClickOutside)
    },
    destroyed() {
        document.removeEventListener('click', this.handleClickOutside)
    }
}
